import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Overline } from "./Reveal";
import { SERVICES } from "./data";
import { scrollToId } from "./SmoothScroll";

const Card = ({ s, i }) => (
  <motion.article
    data-testid={`service-card-${s.id}`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative overflow-hidden rounded-[28px] bg-[#060606] border border-white/10 hover:border-gold/50 transition-colors duration-500 min-h-[420px] lg:min-h-0 ${s.span}`}
  >
    <img src={s.img} alt={`${s.title} ${s.accent}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-1000 ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
    <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/70 to-transparent" />
    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 card-spot" />
    <div className="relative h-full flex flex-col justify-between p-7 sm:p-9">
      <div className="flex justify-between items-start">
        <span className="font-mono text-xs text-gold tracking-[0.2em]">{s.no}</span>
        <span className="w-11 h-11 rounded-full border border-gold/40 grid place-items-center text-gold transition-transform duration-500 group-hover:rotate-45 group-hover:bg-gold group-hover:text-obsidian">
          <ArrowUpRight className="w-4 h-4" />
        </span>
      </div>
      <div>
        <h3 className="font-display text-4xl sm:text-5xl leading-[0.95] text-ivory">
          {s.title}<br /><em className="text-gold-grad">{s.accent}</em>
        </h3>
        <p className="mt-4 max-w-sm text-sm text-ivory/80 leading-relaxed">{s.text}</p>
      </div>
    </div>
  </motion.article>
);

export const Services = () => (
  <section id="servizi" data-testid="services-section" className="relative py-24 sm:py-32 bg-obsidian-2">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
        <div>
          <Overline>I nostri servizi</Overline>
          <h2 className="mt-6 font-display text-5xl sm:text-7xl leading-[0.95] text-ivory">
            <MaskLines lines={["Quattro mondi,", <em key="e" className="text-gold-grad">una firma.</em>]} />
          </h2>
        </div>
        <p className="max-w-sm text-sm sm:text-base text-ivory/70 leading-relaxed">Dal taglio al colore, dalla barba ai trattamenti: ogni servizio è costruito intorno a te.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 lg:auto-rows-[340px] gap-5">
        {SERVICES.map((s, i) => <Card key={s.id} s={s} i={i} />)}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1, delay: 0.15 }}
          className="lg:col-span-7 rounded-[28px] border border-gold/30 bg-gold/[0.06] p-8 sm:p-10 flex flex-col justify-between min-h-[300px]"
        >
          <p className="font-display text-3xl sm:text-5xl leading-[1.05] text-ivory">
            Non sai cosa scegliere? <em className="text-gold-grad">Parliamone insieme.</em>
          </p>
          <div className="flex flex-wrap gap-4 mt-8">
            <button data-testid="services-cta-booking" onClick={() => scrollToId("prenota")} className="btn-gold">Richiedi una consulenza <ArrowUpRight className="w-4 h-4" /></button>
            <button data-testid="services-cta-prices" onClick={() => scrollToId("listino")} className="btn-ghost">Vedi il listino</button>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
